import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { TagLibraryOutput } from '../../../../team-apis/otterdam/outputs/tag-library-output';
import { AbstractNestableOutputComponent } from '../abstract-nestable-output.component';

@Component({
  selector: 'h3-tag-library-output',
  templateUrl: './tag-library-output.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class TagLibraryOutputComponent
  extends AbstractNestableOutputComponent<TagLibraryOutput>
  implements OnInit
{
  whitelist: string[] = [];
  blacklist: string[] = [];

  override ngOnInit() {
    super.ngOnInit();
    const output = this.outputInfoStore.state().output;
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- fix me!
    this.whitelist = output.meta?.whitelist || [];
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- fix me!
    this.blacklist = output.meta?.blacklist || [];
  }
}
